import React, { useEffect, useState } from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
import { AlertCircle, Check, RotateCcw } from 'lucide-react';
export function ExitIntent() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const goToIntermedio = () => {
    setIsOpen(false);
    setTimeout(() => {
      const element = document.getElementById('cta-intermedio');
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }, 300);
  };
  const scrollToPricing = () => {
    setIsOpen(false);
    setTimeout(() => {
      const element = document.getElementById('pricing-section');
      element?.scrollIntoView({
        behavior: 'smooth'
      });
    }, 300);
  };
  const handlePurchaseClick = () => {
    trackAddToCart('Hábitos Atómicos Espirituales', 199, 'MXN');
    window.open('https://pay.hotmart.com/S104255087F?checkoutMode=10&bid=1770183530018', '_blank');
  };
  useEffect(() => {
    const lastShown = localStorage.getItem('exitIntentShown');
    if (lastShown) {
      const timeSinceShown = new Date().getTime() - parseInt(lastShown);
      if (timeSinceShown < 24 * 60 * 60 * 1000) {
        setHasShown(true);
        return;
      }
    }
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !hasShown) {
        showModal();
      }
    };
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [hasShown]);
  const showModal = () => {
    setIsOpen(true);
    setHasShown(true);
    localStorage.setItem('exitIntentShown', new Date().getTime().toString());
  };
  return <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} title="¿Seguro que quieres irte?" data-id="element-64">
      <div className="space-y-5" data-id="element-65">
        <div className="bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-lg p-4" data-id="element-66">
          <p className="text-white text-base md:text-lg font-medium text-center" data-id="element-67">
            Mañana vas a despertar y hacer exactamente lo mismo que hoy.
          </p>
          <p className="text-gray-300 text-sm text-center mt-2" data-id="element-68">
            A menos que hoy decidas instalar un sistema diferente.
          </p>
        </div>

        <div data-id="element-69">
          <p className="text-gray-400 text-xs uppercase tracking-wider mb-3 font-semibold" data-id="element-70">
            Todo esto te espera por solo $7.99 USD:
          </p>
          <ul className="space-y-2" data-id="element-71">
            {['Sistema completo ANCLA (eBook + Audiolibro + Tracker)', 'BONO: Reinicio Express — para cuando fallas', 'BONO: Biblioteca de Señales — para no olvidarte', 'BONO: Plan Anti-Abandono — para sobrevivir el día 4'].map((item, i) => <li key={i} className="flex items-start text-gray-300 text-sm" data-id="element-72">
                <Check className="w-4 h-4 text-[#d4af37] mr-2 mt-0.5 flex-shrink-0" data-id="element-73" />
                <span data-id="element-74">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Guarantee */}
        <div className="flex items-center gap-2 bg-[#1e3a5f]/30 rounded-lg p-3 border border-[#1e3a5f]" data-id="element-75">
          <RotateCcw className="w-5 h-5 text-[#d4af37] flex-shrink-0" data-id="element-76" />
          <p className="text-gray-300 text-xs" data-id="element-77">
            <span className="text-white font-medium" data-id="element-78">
              Te aseguramos que si lo aplicas tu vida va a cambiar.
            </span>
          </p>
        </div>

        <div className="pt-1" data-id="element-79">
          <p className="text-gray-400 text-sm text-center mb-3" data-id="element-80">
            Antes <span className="text-gray-500 line-through" data-id="element-81">$29.99 USD</span>{' '}
            — Ahora{' '}
            <span className="text-[#d4af37] font-bold text-xl" data-id="element-82">$7.99 USD</span>
          </p>
          <Button onClick={goToIntermedio} fullWidth className="shadow-xl" data-id="element-83">
            Quiero ver los planes + los 3 bonos
          </Button>
          <button onClick={() => setIsOpen(false)} className="w-full text-center text-gray-500 text-xs mt-3 hover:text-gray-300 transition-colors py-2" data-id="element-84">
            No, prefiero seguir como estoy
          </button>
        </div>
      </div>
    </Modal>;
}